import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  DashboardOverviewData,
  DashboardOverviewResponse,
  DashboardPeriodPreset,
} from './dashboard.models';

@Injectable({ providedIn: 'root' })
export class DashboardDataService {
  private readonly apiUrl = `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1`;

  constructor(private readonly http: HttpClient) {}

  getOverview(
    customerId: number,
    siteId: number,
    options: {
      preset: DashboardPeriodPreset;
      anchorDate: string;
      paymentsPage: number;
      paymentsPageSize: number;
      treatmentsPage: number;
      treatmentsSort: 'appointments' | 'revenue' | 'hours' | 'revenuePerHour';
      treatmentsOrder: 'asc' | 'desc';
    },
  ): Observable<DashboardOverviewData> {
    const params = new HttpParams()
      .set('preset', options.preset)
      .set('anchorDate', options.anchorDate)
      .set('paymentsPage', options.paymentsPage)
      .set('paymentsPageSize', options.paymentsPageSize)
      .set('treatmentsPage', options.treatmentsPage)
      .set('treatmentsSort', options.treatmentsSort)
      .set('treatmentsOrder', options.treatmentsOrder);
    return this.http
      .get<DashboardOverviewResponse>(
        `${this.apiUrl}/customers/${customerId}/sites/${siteId}/dashboard/overview`,
        { params },
      )
      .pipe(map((response) => response.data));
  }

  shiftAnchor(
    anchorDate: string,
    preset: DashboardPeriodPreset,
    direction: -1 | 1,
  ): string {
    const date = new Date(`${anchorDate}T00:00:00`);
    if (preset === 'today') date.setDate(date.getDate() + direction);
    if (preset === 'week') date.setDate(date.getDate() + direction * 7);
    if (preset === 'month') date.setMonth(date.getMonth() + direction, 1);
    if (preset === 'year') date.setFullYear(date.getFullYear() + direction, 0, 1);
    return this.toDateOnly(date);
  }

  today(): string {
    return this.toDateOnly(new Date());
  }

  private toDateOnly(value: Date): string {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
  }
}
